var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMigrate = function SvgMigrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7202176256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16 0L16 16L0 16L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7202176256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9975 3.0025L10.9975 0L0 0L0 10.9975L3.0025 10.9975L3.0025 13L13 13L13 3.0025L10.9975 3.0025ZM0.9975 10L0.9975 0.9975L10 0.9975L10 10L0.9975 10ZM12.0025 12.0025L4 12.0025L4 11.005L10.9975 11.005L10.9975 4L11.995 4L11.995 12.0025L12.0025 12.0025Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 1 1)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0975 2.9025L11.0975 -0.1L-0.1 -0.1L-0.1 11.0975L2.9025 11.0975L2.9025 13.1L13.1 13.1L13.1 2.9025L11.0975 2.9025ZM10.9975 0L10.9975 3.0025L13 3.0025L13 13L3.0025 13L3.0025 10.9975L0 10.9975L0 0L10.9975 0ZM0.9975 0.9975L0.9975 10L10 10L10 0.9975L0.9975 0.9975ZM1.0975 1.0975L1.0975 9.9L9.9 9.9L9.9 1.0975L1.0975 1.0975ZM4 12.0025L11.995 12.0025L11.995 4L10.9975 4L10.9975 11.005L4 11.005L4 12.0025ZM11.895 11.9025L11.895 4.1L11.0975 4.1L11.0975 11.105L4.1 11.105L4.1 11.9025L11.895 11.9025Z",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 1 1 1)",
    fill: "rgb(0, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91688 0.749602L4.07305 1.9697L0 1.9697L0 3.0303L4.07305 3.0303L2.91688 4.2504L3.6272 5L6 2.50399L3.6272 0L2.91688 0.749602Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 4 4)",
    fill: "rgb(33, 33, 33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6272 -0.145384L2.77911 0.749602L3.84052 1.8697L-0.1 1.8697L-0.1 3.1303L3.84052 3.1303L2.77911 4.2504L3.62709 5.14526L6.13787 2.5041L3.6272 -0.145384ZM3.93528 3.0303L4.07305 3.0303L2.91688 4.2504L3.6272 5L6 2.50399L3.6272 0L2.91688 0.749602L4.07305 1.9697L0 1.9697L0 3.0303L3.93528 3.0303Z",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 1 4 4)",
    fill: "rgb(0, 0, 0)"
  }))));
};
export default SvgMigrate;